export type ISupportedConsoleLevel = 'log' | 'info' | 'warn' | 'error' | 'debug';
export const supportedConsoleLevels: ISupportedConsoleLevel[] = ['log', 'info', 'warn', 'error', 'debug'];
